import React from "react";

import ModalTabs from "app/components/Modal/ModalTabs";

export default ({ children, input, ...rest }) => {
  const { value } = input;

  return (
    <ModalTabs value={value} {...rest}>
      {children}
    </ModalTabs>
  );
};
